import React, { useState } from 'react';
// import {operator} from '../components/affiliate';

function Todo({todo, index}) {
    return (
           
            <li class="card">
              <img src={todo.img} className="card-img-top" alt="..." />
              <div class="card-body">
                  <p className="card__price">{todo.ordpris}</p>
                <h3 class="card__title">{todo.prodnamn}</h3>
                <p className="card__brodtext">{todo.text}</p>
                <a href={todo.recUrl} className="card__link">Läs recension</a>
                <a href={todo.buttonUrl} class="btn btn-warning" target="_blank" rel="noopener noreferrer">Köp nu</a>
              </div>
            </li>  
    )
}

function App() {
    // const namn = {operator};
    // console.log(namn.operator[0]);
    const [todos] = useState([
        {
            img: '/frozen.jpg',
            pris: '279:-',
            ordpris: '279:-',
            prodnamn: 'Kids Frozen',
            text: '3+ år Eltandborste Box',
            recUrl: '/eltandborste-frozen',
            buttonUrl: 'https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-kids-frozen-3--ar-eltandborstebox'
        },
        {
            img: '/starwars.webp',
            pris: '599:-',
            ordpris: '599:-',
            prodnamn: 'Star Wars',
            text: 'Junior D501, 6+ år Eltandborste',
            recUrl: '/eltandborste-starwars',
            buttonUrl: 'https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-junior-d501-star-wars-6--ar-eltandborste'
        },
        {
            img: '/mimmi.webp',
            pris: '599:-',
            ordpris: '599:-',
            prodnamn: 'Mimmi Pigg',
            text: 'Junior D501, 6+ år Eltandborste',
            recUrl: '/eltandborste-mimmi',
            buttonUrl: 'https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-junior-d501-minnie-6--ar-eltandborste'
        }
    ])

    return (
            <ul class="card-show">
                {todos.map((todo, index) => (
                <Todo key={index} index={index} todo={todo} /> 
                ))}
            </ul>
    )

}

export default App;